import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';
import Avatar from '../Avatar/Avatar';

const BlockWithAvatar = ({ className, children, src, avatarSize }) => (
  <div className={classNames(className, BlockWithAvatar.className)}>
    <Avatar
      src={src}
      canEdit={false}
      className={BlockWithAvatar.getClassName('avatar')}
      size={avatarSize}
      circle
    />
    <div className={BlockWithAvatar.getClassName('content')} style={BlockWithAvatar.getContentStyle(avatarSize)}>
      {children}
    </div>
  </div>
);

BlockWithAvatar.className = 'block-with-avatar';
BlockWithAvatar.getClassName = getClassNameGenerator(BlockWithAvatar.className);

BlockWithAvatar.avatarPadding = 15;
BlockWithAvatar.getContentStyle = (avatarSize) => ({
  paddingLeft: avatarSize + BlockWithAvatar.avatarPadding
});

BlockWithAvatar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  src: PropTypes.any,
  avatarSize: PropTypes.number,
};

BlockWithAvatar.defaultProps = {
  avatarSize: 36
};

export default BlockWithAvatar;
